export default {"src":"/_next/static/media/location-marker.41b17a00.svg","height":22,"width":18,"blurWidth":0,"blurHeight":0};